var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.localNavigation},_vm._l((_vm.items),function(ref){
var name = ref.name;
var title = ref.title;
return _c('router-link',{key:name,attrs:{"to":{ name: name, params: _vm.$route.params },"active-class":_vm.$style.on,"tag":"li"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(title))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }